import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName} from '../PatUniv.js'

function PatIpBillSummary(props){

  const {ip_id} = useParams();
  const loc = 1;
  const [inputValue, setInputValue] = useState('');
  const [ipData, setIpData] = useState([]);
  const [labData, setLabData] = useState([]);
  const [invData, setInvData] = useState([]);
  const [drugData, setDrugData] = useState([]);
  const [minviewData, setMinviewData] = useState([]);
  const [totData, setTotData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [advData, setAdvData] = useState([]);
  const [iprefundData, setIprefundData] = useState([]);
  const [hospData, setHospData] = useState([]);
  const currentDate = new Date().toISOString().slice(0,10);

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "pat-edit-ip-admit/" + ip_id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchHosData();
  }, []);
  async function fetchHosData() {
      try {
        const response = await axios.get(baseUrl + "pat-view-hospital/" + loc + '/');
        setHospData(response.data);
      } catch (error) {
        console.log(error);
      }
  }


  useEffect(() => {
    fetchTotData();
  }, []);

  function fetchTotData() {
    axios.get(`${baseUrl}pat-view-ip-tot/${ip_id}/`)
      .then((totResponse) => {
        setTotData(totResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchadvData();
  }, []);

  function fetchadvData() {
    axios.get(`${baseUrl}pat-view-ip-adv/${ip_id}/`)
      .then((advResponse) => {
        setAdvData(advResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchdrugData();
  }, []);

  function fetchdrugData() {
    axios.get(`${baseUrl}pat-view-ip-drug/${ip_id}/`)
      .then((drugResponse) => {
        setDrugData(drugResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchlabData();
  }, []);

  function fetchlabData() {
    axios.get(`${baseUrl}pat-view-ip-lab/${ip_id}/`)
      .then((labResponse) => {
        setLabData(labResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchinvData();
  }, []);

  function fetchinvData() {
    axios.get(`${baseUrl}pat-view-ip-inv/${ip_id}/`)
      .then((invResponse) => {
        setInvData(invResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchminviewData();
  }, []);

  function fetchminviewData() {
    axios.get(`${baseUrl}pat-view-ip-min/${ip_id}/`)
      .then((minviewResponse) => {
        setMinviewData(minviewResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
      fetchIprefData();
  }, []);

  async function fetchIprefData() {
      try {
          const iprefResponse = await axios.get(`${baseUrl}pat-view-ip-refund/${ip_id}/`);
          const status = (iprefResponse.data[0].refund_status);
          if(status == 2){
          setIprefundData(iprefResponse.data);
          }
      } catch (error) {
        console.log(error);
      }
  }

    let drugTotalSum = 0;
    let drugPaidSum = 0;
    for (let i = 0; i < drugData.length; i++) {
      drugTotalSum += parseFloat(drugData[i].total);
      if(drugData[i].mode != 'advance') {
        drugPaidSum += parseFloat(drugData[i].paid) || 0;
      }
    }
    let labTotalSum = 0;
    let labPaidSum = 0;
    for (let i = 0; i < labData.length; i++) {
      labTotalSum += parseFloat(labData[i].lab_tot);
      if(labData[i].lab_pmode != 'advance') {
        labPaidSum += parseFloat(labData[i].lab_paid) || 0;
      }
    }
    let invTotalSum = 0;
    let invPaidSum = 0;
    for (let i = 0; i < invData.length; i++) {
      invTotalSum += parseFloat(invData[i].inv_tot);
      if(invData[i].inv_pmode != 'advance') {
        invPaidSum += parseFloat(invData[i].inv_paid) || 0;
      }
    }
    let advTotalSum = 0;
    let advPaidSum = 0;
    for (let i = 0; i < advData.length; i++) {
      advTotalSum += parseFloat(advData[i].advance);
      advPaidSum += parseFloat(advData[i].paid) || 0;
    }
    let minviewTotalSum = 0;
    for (let i = 0; i < minviewData.length; i++) {
      minviewTotalSum += parseFloat(minviewData[i].min_tot);
    }
    let refTotalSum = 0;
    for (let i = 0; i < iprefundData.length; i++) {
      refTotalSum += parseFloat(iprefundData[i].refund_amount);
    }

    const InvoicedTotal = parseFloat(minviewTotalSum + invTotalSum + labTotalSum + drugTotalSum)
    const PaidTotal = parseFloat(advPaidSum) + parseFloat(drugPaidSum) + parseFloat(invPaidSum) + parseFloat(labPaidSum) - parseFloat(refTotalSum)
    const totdisc = totData.map(row => row.tot_disc);
    const BalanceTotal = parseFloat( PaidTotal - InvoicedTotal) + parseFloat(totdisc)

    const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
     };

    return (
    <section className="container mt-4">
    <div  id="invoice-print">
      <table rules="rows" cellpadding="3" className="text-justify mt-5" width="100%" >
        <thead>
          <tr>
            {hospData.map((hospital) => (
                <td align="right" colSpan="2" >
                  <p align="center">
                 <img
  src={hospital.logo}
  alt="Hospital Logo"
  style={{width:"60px", height:"60px", objectFit:"contain"}}
/>
<strong>{hospital.hospital}</strong><br />
                    Address&nbsp;: &nbsp;{hospital.address}&nbsp;&nbsp;&nbsp;-&nbsp;
                    <br />Phone : {hospital.mobile} &nbsp; Email : {hospital.email} &nbsp; <br />
                    Web : {hospital.website}
                  </p>
                </td>
            ))}
          </tr>
        </thead>
        </table>
    <h4 style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between' }}>
      <span style={{ alignSelf: 'flex-start' }}>FINAL SETTLEMENT BILL/ RECEIPT</span>
      <span style={{ alignSelf: 'flex-end' }}>Date : {currentDate}</span>
    </h4>
    <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip_id}</td>
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{patientData.admit_date}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Billing Summary
    </h3>
  <div className="card card-body">
  <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Drug Date</th>
          <th>Drug ID</th>
          <th>Invoiced</th>
          <th>Total</th>
          <th>Paid</th>
          <th>Balance</th>
        </tr>
  </thead>
  <tbody>
    {drugData.map((drug, index) => (
            <tr key={index}>
            <td>{drug.add_date}</td>
            <td>
              {drug.product.split(",").map((test, i) => (
                <React.Fragment key={i}>
                  {test.trim()}
                  <br />
                </React.Fragment>
              ))}
            </td>
            <td>
              {drug.netamount.split(",").map((amount, i) => (
                <React.Fragment key={i}>
                  {amount.trim()}
                  <br />
                </React.Fragment>
              ))}
            </td>
            <td>{drug.total}</td>
            <td>{drug.paid}</td>
            <td>{drug.balance}</td>
          </tr>
        ))}
    </tbody>
    <tfoot>
      <tr>
        <td colSpan="5" style={{textAlign: 'left', fontWeight: 'bold'}}>Drug</td>
        <td style={{textAlign: 'right', fontWeight: 'bold'}}>Rs. {drugTotalSum.toFixed(2)}</td>
      </tr>
    </tfoot>
    </table>
    </div>
  <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Lab Date</th>
          <th>Lab Test</th>
          <th>Lab Invoiced</th>
          <th>Lab Total</th>
          <th>Lab Paid</th>
          <th>Lab Balance</th>
        </tr>
  </thead>
  <tbody>
    {labData.map((lab, index) => (
            <tr key={index}>
            <td>{lab.add_date}</td>
            <td>
              {lab.lab_test.split(",").map((test, i) => (
                <React.Fragment key={i}>
                  {test.trim()}
                  <br />
                </React.Fragment>
              ))}
            </td>
            <td>
              {lab.lab_amount.split(",").map((amount, i) => (
                <React.Fragment key={i}>
                  {amount.trim()}
                  <br />
                </React.Fragment>
              ))}
            </td>
            <td>{lab.lab_tot}</td>
            <td>{lab.lab_paid}</td>
            <td>{lab.lab_balance}</td>
          </tr>
        ))}
    </tbody>
    <tfoot>
      <tr>
        <td colSpan="5" style={{textAlign: 'left', fontWeight: 'bold'}}>Lab</td>
        <td style={{textAlign: 'right', fontWeight: 'bold'}}>Rs. {labTotalSum.toFixed(2)}</td>
      </tr>
    </tfoot>
    </table>
    </div>
    <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Inv Date</th>
          <th>Inv Test</th>
          <th>Inv Invoiced</th>
          <th>Inv Total</th>
          <th>Inv Paid</th>
          <th>Inv Balance</th>
        </tr>
  </thead>
  <tbody>
    {invData.map((inv, index) => (
          <tr key={index}>
            <td>{inv.add_date}</td>
            <td>
              {inv.inv_test.split(",").map((test, i) => (
                <React.Fragment key={i}>
                  {test.trim()}
                  <br />
                </React.Fragment>
              ))}
            </td>
            <td>
              {inv.inv_amount.split(",").map((amount, i) => (
                <React.Fragment key={i}>
                  {amount.trim()}
                  <br />
                </React.Fragment>
              ))}
            </td>
            <td>{inv.inv_tot}</td>
            <td>{inv.inv_paid}</td>
            <td>{inv.inv_balance}</td>
          </tr>
        ))}
    </tbody>
     <tfoot>
      <tr>
        <td colSpan="5" style={{textAlign: 'left', fontWeight: 'bold'}}>Radiology</td>
        <td style={{textAlign: 'right', fontWeight: 'bold'}}>Rs. {invTotalSum.toFixed(2)}</td>
      </tr>
    </tfoot>
    </table>
    </div>
    <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>IP Bill Date</th>
          <th>IP Bill Test</th>
          <th>IP Bill Invoiced</th>
          <th>IP Bill Total</th>
        </tr>
  </thead>
  <tbody>
    {minviewData.map((min, index) => (
          <tr key={index}>
            <td>{min.add_date}</td>
            <td>
              {min.min_test.split(",").map((test, i) => (
                <React.Fragment key={i}>
                  {test.trim()}
                  <br />
                </React.Fragment>
              ))}
            </td>
            <td>
              {min.min_amount.split(',').map((amount, i) => (
                <React.Fragment key={i}>
                  {amount.trim()}*{min.min_units.split(',')[i].trim()}=
                  {parseInt(amount.trim()) * parseInt(min.min_units.split(',')[i].trim())}
                  {i < min.min_amount.split(',').length - 1 && <br />}
                </React.Fragment>
              ))}
            </td>
            <td>{min.min_tot}</td>
          </tr>
        ))}
    </tbody>
    <tfoot>
      <tr>
        <td colSpan="3" style={{textAlign: 'left', fontWeight: 'bold'}}>IP Bill</td>
        <td style={{textAlign: 'right', fontWeight: 'bold'}}>Rs. {minviewTotalSum.toFixed(2)}</td>
      </tr>
    </tfoot>
    </table>
    </div>
  </div>

    <h4 style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between' }}>
      <span style={{ alignSelf: 'flex-start' }}>Total Invoiced</span>
      <span style={{ alignSelf: 'flex-end' }}>Rs.{InvoicedTotal.toFixed(2)}</span>
    </h4>
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Payment/Invoice List
    </h3>
    <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Date</th>
          <th>Test</th>
          <th>Invoice</th>
          <th>Invoice Amount</th>
          <th>Paid</th>
          <th>Balance</th>
          <th>Mode</th>
        </tr>
  </thead>
  <tbody>
    {advData.map((adv, index) => (
          <tr >
            <td>{adv.add_date}</td>
            <td>{adv.adv_type}</td>
            <td><Link to={`/ip-invoice/${adv.invoice}`} target="_blank">{adv.invoice}</Link></td>
            <td>{adv.advance}</td>
            <td>{adv.paid}</td>
            <td>{adv.balance}</td>
            <td>{adv.mode}</td>
          </tr>
    ))}
    {drugData.map((drug, index) => (
      drug.paid > 0 ? (
          <tr >
            <td>{drug.add_date}</td>
            <td>{drug.product}</td>
            <td><Link to={`/pharm-invoice-other/${drug.sale_id}`} target="_blank">{drug.sale_id}</Link></td>
            <td>{drug.total}</td>
            <td>{drug.paid}</td>
            <td>{drug.balance}</td>
            <td>{drug.mode}</td>
          </tr>
      ) : null
    ))}
    {labData.map((lab, index) => (
       lab.lab_paid > 0 ? (
          <tr >
            <td>{lab.add_date}</td>
            <td>{lab.lab_test}</td>
            <td><Link to={`/lab-invoice-ip/${lab.lab_invoice}`} target="_blank">{lab.lab_invoice}</Link></td>
            <td>{lab.lab_tot}</td>
            <td>{lab.lab_paid}</td>
            <td>{lab.lab_balance}</td>
            <td>{lab.lab_pmode}</td>
          </tr>
       ) : null
    ))}
    {invData.map((inv, index) => (
       inv.inv_paid > 0 ? (
          <tr >
            <td>{inv.add_date}</td>
            <td>{inv.inv_test}</td>
            <td><Link to={`/inv-invoice-ip/${inv.inv_invoice}`} target="_blank">{inv.inv_invoice}</Link></td>
            <td>{inv.inv_tot}</td>
            <td>{inv.inv_paid}</td>
            <td>{inv.inv_balance}</td>
            <td>{inv.inv_pmode}</td>
          </tr>
       ) : null
    ))}
    {minviewData.map((min, index) => (
          <tr >
            <td>{min.add_date}</td>
            <td>{min.min_test}</td>
            <td></td>
            <td>{min.min_tot}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
    ))}
    {totData.map((row, index) => (
      row.tot_disc > 0 ? (
        <tr key={index}>
          <td>{row.add_date}</td>
          <td>Discount Amount</td>
          <td></td>
          <td>{row.tot_disc}</td>
          <td></td>
          <td></td>
          <td>{row.disc_reason}</td>
        </tr>
      ) : null
    ))}
    </tbody>
    </table>
    </div>
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Refund Details
    </h3>
    <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Refund Date</th>
          <th>Refund Type</th>
          <th>Refund Amount</th>
          <th>Receipt</th>
          <th>Received By</th>
          <th>Reason</th>
        </tr>
  </thead>
  <tbody>
    {iprefundData.map((ref, index) => (
          <tr>
            <td>{ref.add_date}</td>
            <td>{ref.refund_type}</td>
            <td>{ref.refund_amount}</td>
            <td><Link to={`/refund-invoice-ip/${ref.receipt}`} target="_blank">{ref.receipt}</Link></td>
            <td>{ref.receivedby}</td>
            <td>{ref.reason}</td>
          </tr>
    ))}
    </tbody>
    </table>
    </div>
    <h4 style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between' }}>
      <span style={{ alignSelf: 'flex-start' }}>Net Payment Amount</span>
      <span style={{ alignSelf: 'flex-end' }}>Rs.{PaidTotal.toFixed(2)}</span>
    </h4>

    <h4 style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between' }}>
      <span style={{ alignSelf: 'flex-start' }}>Balance Amount</span>
      <span style={{ alignSelf: 'flex-end', color: 'red' }}>Rs.{BalanceTotal.toFixed(2)}</span>
    </h4>

    <table border='1' width="100%">
  <thead>
    <tr>
      <th className="text-end"><strong>For {hospData.map(row => row.hospital)}</strong></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td width="100%">
        <table width="100%">
          <tr>
            <th width="100%" className="text-end">Authorized Staff:</th>
          </tr>
          <tr>
            <th width="100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
          </tr>
          <tr>
            <th width="100%" className="text-end">(Name & Signature)</th>
          </tr>
        </table>
      </td>
    </tr>
  </tbody>
</table>
</div>
     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="mt-2">
      <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}
      onClick={handlePrint}
      >
       Print
      </button>
    </div>
    </section>
    )
}

export default PatIpBillSummary;